import Cookies from "js-cookie";
import pick from "lodash/pick";
import get from "lodash/get";
const cookieParser = require("cookie-parser");

const userCookieParams = [
  "authenticated",
  "cookieAccepted",
  "email",
  "id",
  "firstName",
  "lastName",
  "phone",
  "token",
  "avatarId",
  "expires",
];

const defaultConfig = Object.freeze({
  domain: process.env.NEXT_PUBLIC_DOMAIN,
});

const cookieActions = (cookieName, additionalConfig) => {
  const cookieConfig = {
    ...defaultConfig,
    ...additionalConfig,
  };
  return {
    set: (value) => {
      Cookies.set(cookieName, JSON.stringify(value), cookieConfig);
    },
    get: () => {
      const value = Cookies.get(cookieName);
      if(value) {
        return JSON.parse(value);
      }
      return value;
    },
    reset: () => Cookies.remove(cookieName),
  };
};

// ToDo: Eshop - Pass this from above
const userCookieName = `users#${process.env.NEXT_PUBLIC_ENVIRONMENT}`;

export const userCookie = {
  ...cookieActions(userCookieName),
  set: (value) => {
    const cookieValues = pick(value, userCookieParams);
    Cookies.set(userCookieName, JSON.stringify(cookieValues), defaultConfig);
  },
};

export const acceptanceCookie = cookieActions(
  `cookie_accepted#${process.env.NEXT_PUBLIC_ENVIRONMENT}`
);

export const getCookieByName = (cname) => {
  const allCookies = document.cookie.split("; ").reduce((prev, current) => {
    const [name, value] = current.split("=");
    prev[name] = value;
    return prev;
  }, {});
  return get(allCookies, cname);
};

export const getJsonCookie = (name) =>
  cookieParser.JSONCookie(decodeURIComponent(getCookieByName(name)));
